import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usr-loandetails',
  templateUrl: './usr-loandetails.component.html',
  styleUrls: ['./usr-loandetails.component.css']
})
export class UsrLoandetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
